export enum BookingStatus {
  ACCEPTED = 'ACCEPTED',
  CANCELLED = 'CANCELLED',
}

export enum BookingTimeframe {
  UPCOMING = 'UPCOMING',
  PREVIOUS = 'PREVIOUS',
}
